import React from 'react';
import FnSpresskit from './FnSpresskit/FnSpresskit';

const FnSPressKit = () => {
  return <FnSpresskit />;
};

export default FnSPressKit;